import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import http from '@/tscapi/service/httpservice';
import { Cookie } from '@/tscapi/utils/cookie';

export const useGiftcard = () => {
    const base = '/api/v2/';
    const cookie: Cookie = new Cookie();
    const lang = cookie.Language.substring(0, 2) || 'en';

    return {
        ...useMutation({
            mutationFn: async (payload: object) => {
                try {
                    const response = await http.post(`${base}${lang}/giftcardbalance`, payload);
                    return response;
                } catch (error) {
                    return Promise.reject(error);
                }
            },
            onSuccess: async (response, variables, context) => {
                // update detail view directly
                // queryClient.setQueryData(
                //     ['bag', response.data.CartGuid, cookie.UserAccessToken?.Edp, cookie.Language],
                //     response.data as TmCart,
                // );
            },
            // onError: (error, variables, context) => {
            //     console.log('error');
            // },
        }),
    };
};
